<template>
  <div id="home">
    <slide id="jumbotron">
      <logo :light="true" :konami="konami" id="logo" />
      <code>npm install discord-sensei</code><br />
    </slide>

    <section id="info">
      <div class="info-item">
        <h2>About</h2>
        <p>
          discord-sensei is a <a href="https://nodejs.org/">node.js</a> module that makes the development of Discord Bots extremely easy. It
          serves as a wrapper around <a href="https://discord.js.org/">discord.js</a> with a workflow thats easy to get used to and is well organized.<br>
          <a href="https://discord.js.org/">discord.js</a> is a great library for interacting with the <a href="https://discordapp.com/developers/docs">Discord</a> API and it covers nearly 100% of the Entire API. Big Thanks to them for 
          making everyone's lives a whole lot easier.
        </p>
        <p>
          Simplicity, and Being Straightforward to use while having a clean workflow was the inspiration behind this project.
        </p>
      </div>

      <div class="info-item">
        <h2>Basic Setup</h2>
        <pre><code class="javascript" v-hljs>const { SenseiClient } = require("discord-sensei");
const path = require("path");

const client = new SenseiClient({
    prefixes: ["!"],
    commandsDirectory: path.join(__dirname, "/commands")
});

client.login("YOUR.BOT.TOKEN");
</code>
</pre>
      </div>

      <div class="info-item">
        <h2>Some of the Features</h2>
        <p>
          <ul>
            <li>Built on <a href="https://discord.js.org/">discord.js</a>, Same Coding Practices!</li>
            <li>Simple, Clean and Organized.</li>
            <li>Automated Message and Argument Parsing.</li>
            <li>Powerful Command Class.</li>
            <li>Arguments with Data types.</li>
            <li>Convient Permissions Setup</li>
            <li>Written in TypeScript.</li>
            <li>Many many more features to come...</li>
          </ul>
        </p>
      </div>

      <div class="info-item">
        <h2>Who is this for ?</h2>
        <p>
          If you want a Framework that lets users do all the fun stuff without letting them worry about the Management/Boilerplate work underneath all while keeping everything clean and organized, then you'd definitely be interested in checking this out!
        </p>
      </div>

      <div class="full-info-item">
        <router-link to="/docs" class="big-ass-btn">Browse the Documentation</router-link>
        <a href="https://discord.gg/8hxuRZn" target="_blank" class="big-ass-btn">Discord Server</a>
        <a href="https://github.com/demonicious/sensei" target="_blank" class="big-ass-btn">Github</a>
      </div>
    </section>
  </div>
</template>

<script>
import Logo from '../Logo.vue';
import Stats from '../Stats.vue';
import MainSource from '../../data/MainSource';

export default {
  name: 'home',
  props: ['konami'],
  components: {
    Logo,
    Stats,
  },

  mounted() {
    this.$emit('setRepository', MainSource.repo);
  },
};
</script>

<style lang="scss">
  @import '../../styles/theming';
  @import '../../styles/mq';

  #home {
    text-align: center;
    background: $color-content-bg;
    color: $color-content-text;

    h2 {
      font-size: 2rem;
      margin: 0;
      font-weight: 600;
      letter-spacing: -1px;
    }

    p {
      font-size: 1rem;
      line-height: 2rem;
      text-align: left;

      @include mq($until: tablet) {
        margin: 0 1rem;
      }

      & > a {
        font-weight: bold;
      }

      &.center {
        text-align: center;
      }
    }

    #jumbotron {
      flex: 0 0 100%;
      padding: 80px 16px;
      background-color: $color-primary;
      background-image: linear-gradient(top, $color-primary, darken($color-primary, 5%));

      code {
        display: inline-block;
        padding: 16px;
        border-radius: 5px;
        background: #f5f5f5;
        color: $color-content-text;
        font-family: $font-monospace;
      }
    }

    #logo {
      display: block;
      margin: 16px auto;
      width: 95%;
      max-width: 700px;
      overflow: visible;
      filter: drop-shadow(0 3px 4px #333);
    }

    #info {
      display: flex;
      flex-flow: row wrap;
      margin: 64px auto 0 auto;
      max-width: 1120px;

      @include mq($until: tablet) {
        margin: 32px auto 0 auto;
      }
    }

    .info-item {
      flex: 1 1 45%;
      padding: 24px;

      ul {
        display: inline-block;
        margin: 0 auto;
        text-align: left;
      }

      pre {
        padding: 8px;
        border-radius: 4px;
        text-align: left;
        font-size: 0.875rem;
        background: #F0F0F0;
      }
    }

    .full-info-item {
      flex: 1 0 100%;
      margin: 48px 0;
    }

    .big-ass-btn {
      display: inline-block;
      padding: 12px 10px;
      border-radius: 4px;
      background: $color-primary;
      color: white;
      font-size: 1.1rem;

      &:hover {
        background: lighten($color-primary, 10%);
      }

      &:not(:first-of-type) {
        margin-left: 8px;
      }

      &.discord {
        background-color: #7289da;

        &:hover {
          background: lighten(#7289da, 10%);
        }
      }
    }
  }

  #app.dark #home {
    background: $color-content-bg-dark;
    color: $color-content-text-dark;

    pre {
      background: lighten($color-content-bg-dark, 4%);
      color: darken($color-content-text-dark, 20%);
    }
  }
</style>
